import $ from 'jquery';

require('bootstrap\\js\\tooltip.js');
require('bootstrap\\js\\popover.js');

export default class TooltipController {
    static init() {
        $(document).ready(() => {
            // Append modal dialogs from forms engine to body element
            $("[id$='SOS_Form_Widget_Container'] .modal.fade").appendTo('body');
            $("[data-toggle='tooltip']").tooltip();
            $("[data-toggle='popover']").popover();
            if ($('[rel=tooltip]').length) {
                $('[rel=tooltip]').tooltip();
            }
        });
    }
}
